/* Announcement links retain their destinations when Klaviyo is unavailable. */
window.openAnnouncementKlaviyoForm = function (event, formId) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href]');
  if (!link || link.hasAttribute('download')) return;
  formId = formId.trim();
  const onsite = window._klOnsite;
  // A pending array has push(), but cannot display a form yet.
  if (!formId || !onsite || typeof onsite.openForm !== 'function' || typeof onsite.push !== 'function') return;
  try {
    onsite.push(['openForm', formId]);
  } catch (error) {
    return;
  }
  event.preventDefault();
};
